import * as React from "react";

function NovatechIcon(props) {
  const { className, height, width } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 122 28"
    >
      <defs>
        <clipPath>
          <rect width="122" height="28" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip-novatech)">
        <path
          data-name="Path 7085"
          d="M-44.082,0h-3.309l-6.467-11.247V0H-56.94V-15.834h3.47L-47.165-4.78V-15.834h3.083Zm9.647.44a6.9,6.9,0,0,1-5.188-1.848A8.542,8.542,0,0,1-42.03-7.938q0-4.351,2.406-6.531a6.9,6.9,0,0,1,5.188-1.848,6.9,6.9,0,0,1,5.188,1.848q2.4,2.181,2.4,6.531a8.563,8.563,0,0,1-2.4,6.531A6.9,6.9,0,0,1-34.435.44Zm3.126-4.254A6.5,6.5,0,0,0-30.16-7.938a6.484,6.484,0,0,0-1.155-4.12,3.774,3.774,0,0,0-3.121-1.456,3.824,3.824,0,0,0-3.137,1.45,6.417,6.417,0,0,0-1.171,4.125,6.417,6.417,0,0,0,1.171,4.125,3.824,3.824,0,0,0,3.137,1.45A3.794,3.794,0,0,0-31.309-3.813Zm5.372-12.021H-22.4l3.438,12.021,3.47-12.021h3.438L-17.462,0h-3.126ZM-2.884-3.255H-8.717L-9.813,0h-3.459l5.65-15.834h3.738L1.724,0H-1.864Zm-.924-2.729-1.977-6.23-2.041,6.23Zm16.984-9.851v2.8H8.438V0H5.108V-13.03H.349v-2.8ZM25.691-6.918H18v4.071h8.766V0h-12V-15.834H26.378v2.8H18v3.362h7.691ZM40.075-1.182A6.454,6.454,0,0,1,35.542.44a6.83,6.83,0,0,1-5.371-2.191,8.771,8.771,0,0,1-1.955-6.037,8.7,8.7,0,0,1,2.224-6.392,6.626,6.626,0,0,1,4.92-1.955q4,0,5.844,2.621a5.674,5.674,0,0,1,1.1,2.954H38.99a4.469,4.469,0,0,0-.827-1.719,3.364,3.364,0,0,0-2.675-1.031,3.316,3.316,0,0,0-2.847,1.456A7,7,0,0,0,31.6-7.734a6.141,6.141,0,0,0,1.1,3.991,3.479,3.479,0,0,0,2.8,1.327,3.2,3.2,0,0,0,2.653-1.139,4.946,4.946,0,0,0,.838-1.837h3.276A7.12,7.12,0,0,1,40.075-1.182ZM53.793,0V-7.068H47.606V0H44.329V-15.834h3.276V-9.8h6.188v-6.037H57.08V0Z"
          transform="translate(63 23)"
          fill="#2b50b5"
        />
      </g>
    </svg>
  );
}

export default NovatechIcon;
